// extracted by mini-css-extract-plugin
export default {"imageContainer":"styles_imageContainer__dbqUJ","image":"styles_image__F-0+a","smallSize":"styles_smallSize__m6PFf"};